module.exports = __webpack_public_path__ + "static/images/video_arr.1167e35.png";